import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types'
import { path } from 'ramda'
import React from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { selectEasymsRates } from '../../../../../selectors/bookingSelectors/bookingEasymsSelector'
import RateEditDialog from './RateEditDialog'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    }
})

class RatesTable extends React.Component {
    state = {
        openId: null
    }

    handleUpdate = rate => {
        this.props.onUpdate(rate)
    }

    handleOpenDialog = openId => {
        this.setState({ openId })
    }

    handleCloseDialog = () => {
        this.setState({ openId: null })
    }

    handleDelete = remoteId => () => {
        const toastrConfirmOptions = {
            onOk: () => this.props.onDelete(remoteId)
        }
        toastr.confirm('Ви впевнені, що хочете видалити цей тариф?', toastrConfirmOptions)
    }

    renderEasymsRateCell = id => {
        const rate = path(['name'], this.props.easymsRates[id])
        return rate ? (
            <span>
                <em>{rate}</em>
                <strong>{' (id: ' + id + ')'}</strong>
            </span>
        ) : null
    }

    render() {
        const { classes, rates = [] } = this.props
        const { openId } = this.state

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID організації</TableCell>
                            <TableCell>Тариф EasyMS</TableCell>
                            <TableCell>Тариф Booking.com</TableCell>
                            <TableCell>Організація Booking.com</TableCell>
                            <TableCell padding="checkbox" />
                            <TableCell padding="checkbox" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rates.map(item => (
                            <TableRow hover key={item.remoteId}>
                                <TableCell>{item.organizationId}</TableCell>
                                <TableCell>{this.renderEasymsRateCell(item.ourId)}</TableCell>
                                <TableCell>
                                    <span>
                                        <em>{item.remoteName}</em>
                                        <strong>{' (id: ' + item.remoteId + ')'}</strong>
                                    </span>
                                </TableCell>
                                <TableCell>{item.remotePropertyId}</TableCell>
                                <TableCell padding="none">
                                    <RateEditDialog
                                        item={item}
                                        open={openId === item.remoteId}
                                        onOpen={this.handleOpenDialog}
                                        onClose={this.handleCloseDialog}
                                        onUpdate={this.handleUpdate}
                                    />
                                </TableCell>
                                <TableCell padding="none">
                                    <IconButton
                                        title="Delete"
                                        aria-label="Delete"
                                        onClick={this.handleDelete(item.remoteId)}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

RatesTable.propTypes = {
    classes: PropTypes.object.isRequired,
    rates: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired
}

export default connect(state => ({
    easymsRates: selectEasymsRates(state)
}))(withStyles(styles)(RatesTable))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/BookingTab/MappingTabs/RatesTab/RatesTable.js